import React from 'react';
import { Grid, Box, Card } from '@material-ui/core';
import get from 'lodash/get';
import { injectIntl, IntlShape } from 'react-intl';

import { LargeSectionHeader, ShortBody } from 'components/Typography';
import { OrangeButton } from 'components/Button';
import { useLayoutStyles } from 'containers/SignupPages/styles';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import PAGES from 'routes/pages';
import { StyledBox } from 'containers/EpargnPendingVerificationPage/styles';
import messages from 'containers/EpargnPendingVerificationPage/messages';
import { translate } from 'helpers/intl';

const EpargnPendingVerificationPage = (props: { intl: IntlShape }) => {
  const classes = useLayoutStyles();

  return (
    <Grid
      className={classes.wrapper}
      container
      justify="center"
      alignContent="center"
    >
      <Box className={classes.box}>
        <Card className={classes.paper}>
          <StyledBox paddingX={[4, 8, 12]} paddingY={5}>
            <img src={get(AssuranceIcon, 'stopWatch')} alt="stop-watch" />
            <LargeSectionHeader weight="500">
              {translate(get(messages, 'title'), props)}
            </LargeSectionHeader>
            <ShortBody weight="400">
              {translate(get(messages, 'subTitle'), props)}
            </ShortBody>
            <OrangeButton
              onClick={() => pushTo(PAGES.LOGIN)}
              variant="contained"
            >
              {translate(get(messages, 'login'), props)}
            </OrangeButton>
          </StyledBox>
        </Card>
      </Box>
    </Grid>
  );
};

export default injectIntl(EpargnPendingVerificationPage);
